import { render, staticRenderFns } from "./FeedSwitch.vue?vue&type=template&id=31a9bcdc"
import script from "./FeedSwitch.vue?vue&type=script&lang=ts"
export * from "./FeedSwitch.vue?vue&type=script&lang=ts"
import style0 from "./FeedSwitch.vue?vue&type=style&index=0&id=31a9bcdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports